$(document).ready(function () {

  var productId = 7441953587253;
  console.log('productId:', productId);

  // Default quantity
  if (productId === 7441953587253) {
    $('quantity-selector .quantity__input').val(2);
  }

  function updateImage() {

    // 👉 ПРОВЕРКА: есть ли вообще варианты Color
    var $colorInputs = $('input[name="Color"]');

    // ❗️Если вариантов нет — выходим и НИЧЕГО НЕ ТРОГАЕМ
    if ($colorInputs.length === 0) {
      console.log('No color variants → keep rendered image');
      return;
    }

    // Есть варианты → работаем дальше
    var selectedValue = $colorInputs.filter(':checked').val();

    // Hide all
    $('.terracotta_image, .slate_image').hide();

    // Show needed
    if (selectedValue === "Terracotta") {
      $('.terracotta_image').show();
    } else if (selectedValue === "Slate") {
      $('.slate_image').show();
    }
  }

  // Run on load
  updateImage();

  // Run on change (ТОЛЬКО если варианты есть)
  $(document).on('change', 'input[name="Color"]', updateImage);

  /* ======================
     DISCOUNT QTY BUTTONS
  ======================= */

  $('.discount-inner').click(function () {
    $('.discount-inner').removeClass('active');
    $(this).addClass('active');

    var Qty = $(this).attr('value');
    console.log('Qty:', Qty);

    $('quantity-selector .quantity__input').val(Qty);
    $('#prdcurrentValue').val(Qty);
  });

});